import { withStyles } from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import { CyNumber } from "../../utilities/number";
import moment from "moment";

const styles = (theme) => ({
  root: {
    '& p, ul': {
      marginBottom: 10,
      '&.hidden': {
        display: 'none'
      }
    },
    '& h5': {
      fontSize: 20,
      lineHeight: 1.4,
      marginBottom: 10,
      fontWeight: 500,
      '&.hidden': {
        display: 'none'
      }
    },
    '& table': {
      tableLayout: 'fixed',
      marginBottom: 16,
      width: '100%',
      borderSpacing: 0,

      '& th, td': {
        'display': 'table-cell',
        'padding': 16,
        'fontSize': 18,
        'textAlign': 'left',
        'lineHeight': 1.43,
        'border-bottom': '1px solid rgba(224, 224, 224, 1)',
      },

      '& tr': {
        height: 48,
        'border-bottom': '1px solid rgba(224, 224, 224, 1)',
      },

      '& td': {
        padding: '0 2px',
        fontSize: 12,
        maxWidth: 65,      
      },
      '& th': {
        color: theme.palette.primary.main,
        padding: '0 2px',
        fontSize: 13,
        maxWidth: 65,
        wordWrap: 'break-word',
        fontWeight: 500,      
      }
    },
    '& .prim-color-highlight': {
      color: theme.palette.primary.main
    },
  },
});

const IndividualDisclosure = withStyles(styles)((
  {
    disclosure,
    classes ,
    data
  }
) => {
  /**
   * @type {string}
   */
  let cleanDisclosure = disclosure;
  if (data) {
    cleanDisclosure = cleanDisclosure
      .replace('[MC_PORTFOLIO_RETURN]', CyNumber.PercentageParser(data['MC_PORTFOLIO_RETURN']) || '')
      .replace('[MC_STANDARD_DEVIATION]', CyNumber.PercentageParser(data['MC_STANDARD_DEVIATION']) || '')
      .replace(
        '[MC_START_DATE]',
        moment(data['MC_START_DATE'])
          .subtract(2, 'months')
          .startOf('month')
          .format('MM/DD/YYYY') || '')
  } else {
    cleanDisclosure = cleanDisclosure.replace('mc_data_class', 'hidden')
  }
  return <React.Fragment>
    {
      cleanDisclosure
        .split('<!--page-->')
        .map((__html, i) => {
          return <section
            key={`section-disclosure-${i}`}
            className={`content disclaimer-and-disclosure ${classes.root}`}
            dangerouslySetInnerHTML={{ __html }} />
        })
    }
  </React.Fragment>
});

const SummaryDisclosures = (
  {
    summaryDisclosures,
    platformDisclosure,
    data
  }
) => (
  <React.Fragment>
    {
      summaryDisclosures &&
      <IndividualDisclosure
        disclosure={summaryDisclosures}
        data={data}
      />
    }
    <IndividualDisclosure
      disclosure={platformDisclosure}
      data={data}
    />
  </React.Fragment>
);

const mapStateToProps = ({ app: { platformDisclosure, summaryDisclosures } }) => ({
  summaryDisclosures, platformDisclosure
});
export default connect(mapStateToProps)(SummaryDisclosures);



// WEBPACK FOOTER //
// ./src/components/Content/SummaryDisclosures.jsx